import { ReactElement } from 'react';
import { IntlProvider } from 'react-intl';
import { ServiceWorkerUpdateAlert } from 'components/core/ServiceWorkerUpdateAlert';
import { getUnescapedTranslationObjectByLocale } from 'intl/getUnescapedTranslationObjectByLocale';
import { removeEscapingBackslash } from 'intl/helpers';
import { alignServiceWorkerOrRepair } from 'services/serviceWorker/alignment';
import { getUiStoreState } from 'store/ui';

/**
 * Shown instead of the app when the worker could not be brought to the page's
 * version: the same "new version available" alert as the update banner.
 * Rendered before the app's providers, so it brings its own translations.
 */
export function ServiceWorkerUpdateRequired(): ReactElement {
  const locale = getUiStoreState().data.currentLocale;
  const messages = removeEscapingBackslash<Record<string, string>>({
    ...getUnescapedTranslationObjectByLocale(locale),
  });

  return (
    <IntlProvider locale={locale} messages={messages}>
      <ServiceWorkerUpdateAlert onRefresh={() => void alignServiceWorkerOrRepair('service-worker-alignment')} />
    </IntlProvider>
  );
}
